import { useState } from 'react';

type State = 'idle' | 'sending' | 'success' | 'error';

export function Pilot() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [product, setProduct] = useState('');
  const [question, setQuestion] = useState('');
  const [website, setWebsite] = useState('');
  const [state, setState] = useState<State>('idle');
  const [message, setMessage] = useState('');

  async function request() {
    setState('sending');
    setMessage('');
    try {
      const response = await fetch('/_pilot', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ name, email, product, question, website }),
      });
      const body = await response.json().catch(() => ({})) as { error?: string; reference?: string };
      if (!response.ok) throw new Error(body.error || 'We could not receive your request. Please try again.');
      const dataLayer = (window as Window & { dataLayer?: unknown[] }).dataLayer;
      dataLayer?.push({ event: 'pilot_request_submitted' });
      window.dispatchEvent(new CustomEvent('persivo:pilot-requested', { detail: { reference: body.reference } }));
      setState('success');
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'We could not receive your request. Please try again.');
      setState('error');
    }
  }

  return <section className="pilot-section" id="pilot"><div className="wrap pilot-grid"><div><p className="eyebrow">START WITH ONE USE CASE</p><h2 className="section-title">Let’s put your product<br/><em>in the conversation.</em></h2><p>Choose a workflow worth showing. Start a conversation with us about a focused demo around the questions your buyers ask.</p><ol><li><span>01</span> Pick a product journey.</li><li><span>02</span> Define the questions and approved story.</li><li><span>03</span> Review the experience together.</li></ol></div>
    {state === 'success' ? <div className="pilot-form pilot-success" role="status">
      <span className="pilot-success-mark" aria-hidden="true">✓</span>
      <p className="eyebrow">REQUEST RECEIVED</p>
      <h3>Thanks, {name.split(/\s+/)[0]}.</h3>
      <p>We’ll review the product and the story you want buyers to understand, then reply to <strong>{email}</strong>.</p>
      <button type="button" className="text-link" onClick={() => { setState('idle'); setName(''); setEmail(''); setProduct(''); setQuestion(''); }}>Send another request <span aria-hidden="true">↗</span></button>
    </div> : <form className="pilot-form" onSubmit={e => { e.preventDefault(); void request(); }}>
      <h3>Build a demo with us.</h3>
      <div className="pilot-form-row">
        <label>Your name<input value={name} onChange={e => setName(e.target.value)} autoComplete="name" placeholder="Your name" required minLength={2} maxLength={100}/></label>
        <label>Work email<input type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" placeholder="you@company.com" required maxLength={254}/></label>
      </div>
      <label>Your product<input value={product} onChange={e => setProduct(e.target.value)} placeholder="Product name or website" required minLength={2} maxLength={200}/></label>
      <label>What should a buyer understand?<textarea value={question} onChange={e => setQuestion(e.target.value)} placeholder="For example: how our approval workflow works" rows={3} required minLength={10} maxLength={1500}/></label>
      <label className="pilot-trap" aria-hidden="true">Website<input value={website} onChange={e => setWebsite(e.target.value)} tabIndex={-1} autoComplete="off"/></label>
      <button className="btn solid" type="submit" disabled={state === 'sending'}>{state === 'sending' ? 'Sending…' : 'Request a pilot ↗'}</button>
      <p className={`pilot-note${state === 'error' ? ' is-error' : ''}`} role="status">{state === 'error' ? message : <>We’ll use these details to respond to your request. <a href="/privacy">Privacy</a></>}</p>
      <a className="pilot-contact" href="mailto:hemant@persivo.co">Prefer email? Write to hemant@persivo.co ↗</a>
    </form>}
  </div></section>;
}
